<!--
  污泥生产量 组件
-->

<template>
  <div class="today_data">
    <ContentSection
      :title="'污泥生产量'"
      :mainStyle="{ borderLeftStyle: 'solid' }"
      :position="'right'"
    >
      <div class="today_main">
        <ul>
          <li v-for="(item, index) in data" :key="index">
            <!-- 左边装饰小图标 -->
            <div v-if="index == 0" class="sep_icon">
              <div class="sep1"></div>
              <div class="sep2"></div>
            </div>
            <!-- 内容 -->
            <div class="today_content">
              <div class="value">
                <span>{{ item.value }}</span>
                <br />
                <span>T</span>
              </div>

              <img
                class="back_img"
                :src="require(`@/assets/img/today_back${index}.png`)"
              />

              <div class="name">
                <!-- <img src="@/assets/img/sanjiao.png" /> -->
                <span>{{ item.name }}</span>
                <!-- <img
                  style="transform: scale(-1)"
                  src="@/assets/img/sanjiao.png"
                /> -->
              </div>
            </div>
            <!-- 中间装饰小图标 -->
            <div v-if="index < data.length - 1" class="sep_icon">
              <div class="sep1"></div>
              <div class="sep2"></div>
              <div class="sep1"></div>
            </div>
            <!-- 右边装饰小图标 -->
            <div v-if="index == data.length - 1" class="sep_icon">
              <div class="sep2"></div>
              <div class="sep1"></div>
            </div>
          </li>
        </ul>
      </div>
    </ContentSection>
  </div>
</template>

<script>
import ContentSection from "@/components/ContentSection";
import { listDeviceRealApi, getHistorysApi } from "@/api/basic.js";
export default {
  name: "todayData",
  components: {
    ContentSection,
  },
  data() {
    return {
      // 今日污水处理数据
      data: [
        {
          name: "今日污泥生产量",
          value: "0",
        },
        {
          name: "近30日污泥生产量",
          value: "0",
        },
        {
          name: "污泥总生产量",
          value: "0",
        },
      ],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      const equipmentids =
        "ca8fb182-5dbb-4653-a045-30cd75a0181b,a5b8d137-7a1f-4d11-bfa4-54473831ba37";
      // 1#2#污泥料仓id
      // 实时污泥数据
      // listDeviceRealApi({equipmentids}).then(res=>{
      let res = listDeviceRealApi();
      // console.log(res)
      if (res.errorcode == 0) {
        const one = Number(res.resultdata.rows[0].ListParam[0].Value);
        const two = Number(res.resultdata.rows[1].ListParam[0].Value);
        this.data[0].value = one + two;
      }
      // })
      // 近30日污泥数据
      let nowDate = new Date();
      let startDate = new Date(nowDate - 30 * 24 * 60 * 60 * 1000);
      // console.log(nowDate,startDate)
      let endtime = this.$formatDate(nowDate);
      let starttime = this.$formatDate(startDate);
      getHistorysApi({ equipmentids, starttime, endtime }).then((res) => {
        console.log(res);
      });
    },
  },
};
</script>


<style lang="less" scoped>
.today_data {
  .today_main {
    width: 100%;
    height: 100%;
    display: flex;
    color: #fff;

    ul {
      margin: auto;
      display: flex;

      li {
        display: flex;
        align-items: center;

        // 内容部分样式
        .today_content {
          position: relative;

          .value {
            position: absolute;
            top: 80vh * @vh;
            left: 50%;
            transform: translate(-50%);
            font-size: 36px;

            span {
              font-size: 18px;
            }
          }

          .back_img {
            width: 203px;
          }

          .name {
            img {
              width: 13px;
              height: 18vh * @vh;
            }

            span {
              font-size: 24px;
              margin: 0 15px;
            }
          }
        }

        // 装饰 分隔图标
        .sep_icon {
          display: flex;

          .sep1 {
            width: 8vw * @vw;
            height: 8vw * @vw;
            border-radius: 50%;
            background: rgba(0, 143, 255, 0.5);
            margin-right: 10vw * @vw;
          }

          .sep2 {
            width: 15px;
            height: 15px;
            border-radius: 50%;
            background: rgba(0, 143, 255, 1);
            margin-right: 10vw * @vw;
          }
        }
      }
    }
  }
}
@media screen and (min-width: 3640px), screen and(max-height: 1080) {
  .today_data {
    .today_main {
      ul {
        li {
          // 内容部分样式
          .today_content {
            .back_img {
              width: 123px;
            }
            .value {
              font-size: 26px;
              span {
                font-size: 28px;
              }
            }
          }
          .name {
            img {
              width: 13px;
              height: 18vh * @vh;
            }
            span {
              font-size: 24px ;
              margin: 0 15px;
            }
          }
        }
      }
    }
  }
}
</style>